import React from 'react';
import PropTypes from 'prop-types';
import Text from '../text';
import { SIZES, APPEARANCES, TYPES, ALIGN } from './constants';

const Paragraph = ({
  children,
  size = SIZES.medium,
  appearance = APPEARANCES.highEmphasis,
  align = ALIGN.left,
  isClipped = false,
}) => (
  <Text
    type={TYPES.paragraph}
    size={size}
    appearance={appearance}
    align={align}
    isClipped={isClipped}
  >
    {children}
  </Text>
);

export default Paragraph;

Paragraph.propTypes = {
  children: PropTypes.node.isRequired,
  size: PropTypes.oneOf(Object.values(SIZES)),
  appearance: PropTypes.oneOf(Object.values(APPEARANCES)),
  align: PropTypes.oneOf(Object.values(ALIGN)),
  isClipped: PropTypes.bool,
};
